<template>
  <div class="content">
    <img :src="imageUrl" alt="" />
  </div>
</template>

<script>

export default {
  name: "replacementModal",
  data() {
    return {
      imageUrl: "",
      modelName: ""
    }
  },
  methods: {
    ctaAction() {
      window.location = `${this.$store.getters["utils/baseUrl"]('customizer')}/customizer.${this.modelName}.html`;
    }
  },
  created() {
    if(!this.$store.state.utils.pdm) return;
    this.modelName = this.$store.state.utils.pdm.model_redirect;
    const { modal_redirect: pdmViews } =  this.$store.state.utils.pdm.product_images.featured_views;
    this.$store.dispatch('utils/GET_PDM', { setData: false, modelName: this.modelName}).then(data => {
      this.$store.dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID", {
          recipe_id: data.default_recipe,
          locale: getLocale(),
          type: "customizer",
          ...pdmViews
        })
        .then(data => {
          this.imageUrl = data[pdmViews.view + "_view"][pdmViews.size];
        });
    });
  }
};
</script>
